import { useQuery } from "@tanstack/react-query";
import { 
  SIDEBAR_COUNT_PRODUCTS,
  ISidebarCount
} from "./types";
import {
  getSidebarCountProduct
} from "./requests";

export const useGetSidebarCountProduct = () => 
  useQuery<ISidebarCount>(SIDEBAR_COUNT_PRODUCTS, () => getSidebarCountProduct());